import axios from 'axios';
import { useUserStore } from '@/stores/user'
import { useIdleStore } from '@/stores/idle'
/*import { useLayoutStore } from "@/stores/layout.js";*/

const apiUrl = import.meta.env.VITE_API_URL

axios.defaults.baseURL = apiUrl;

// Evitar múltiples redirecciones a login cuando varias peticiones reciben 401 a la vez
let redirectingToLogin = false;

const urlsExcludedForBearerHeader = [
  '/auth/login',
  '/login',
  '/register',
  '/password-recovery',
  '/password-reset',
  '/sl',
];

axios.interceptors.request.use(
  (request) => {
    const userStore = useUserStore();

    if (urlsExcludedForBearerHeader.indexOf(request.url) === -1) {
      request.headers['accept-language'] = localStorage.getItem("locale") ?? "es_ES";
      request.headers.Authorization = `Bearer ${userStore.token}`;
    }

    // Enviar socket ID para que broadcast()->toOthers() excluya solo esta conexión
    if (window.Echo?.socketId?.()) {
      request.headers['X-Socket-Id'] = window.Echo.socketId();
    }

    return request;
  },
  (err) => Promise.reject(err)
);

axios.interceptors.response.use(
  (response) => {

    /*const layoutStore = useLayoutStore();

    // Do something with response data
    layoutStore.isFormModified = false;*/

    return response.data;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // No interceptar 401 en peticiones marcadas como reauth del idle
        if (error.config?._isIdleReauth) {
          return Promise.reject(error);
        }

        if (redirectingToLogin) {
          return Promise.reject(error);
        }
        redirectingToLogin = true;
        const userStore = useUserStore();
        const idleStore = useIdleStore();
        userStore.setLogout();
        idleStore.stopWatching();
        idleStore.$reset();
        window.location.href = '/login';
        return Promise.reject(error);
      }
    } else {
      console.log('Error sin respuesta del servidor, revisar la conexión o problemas de red');
    }

    return Promise.reject(error);
  }
);